'use strict';

module.exports = {
    LANG: 'fr-fr',
    SIGN: 'Se connecter',
    REGISTER: 'Inscription',
    QUICK_ACCESS: 'Accès rapide avec',
    SIGN_JOIN: 'Se connecter ou s\'inscrire gratuitement !',
    NOT_MEMBER: 'Pas encore membre ?',
    ALREADY_MEMBER: 'Déjà un membre d\'AliExpress/Alibaba ?',
    SHOW_ALL: 'Montrer tous les',
    HIDE: 'Cacher'
};